import React from 'react';
import { OperationData, OperationVariables, gql } from '@ts-gql/tag';
import { useMutation } from '@ts-gql/apollo';

const mutation = gql`
  mutation jobSignOffWithdraw($cloudId: String!) {
    jobSignOffWithdraw(input: { cloudId: $cloudId }) {
      correlationId
      validationMessage {
        field
        message
      }
      messagesSuccessfullyProcessed
    }
  }
` as import('../../__generated__/ts-gql/jobSignOffWithdraw').type;

export type JobSignOffWithdrawVariables = OperationVariables<typeof mutation>;
export type JobSignOffWithdrawResult = OperationData<typeof mutation>;

export const useJobSignOffWithdraw = () => {
  const tuple = useMutation(mutation);

  const [_mutate, result] = tuple;

  const mutate = React.useCallback<typeof _mutate>(
    (options) =>
      _mutate({
        context: { service: 'core' },
        refetchQueries: [
          'GetJob',
          'GetJobComments',
          'GetNotificationCountForUser',
        ],
        // refetchQueries: [
        //   {
        //     query: getJobQuery,
        //     variables: { cloudId: options.variables.cloudId },
        //   },
        //   {
        //     query: getJobCommentsQuery,
        //     variables: { cloudId: options.variables.cloudId },
        //   },
        // ],
        awaitRefetchQueries: true,
        update(cache) {
          cache.evict({ fieldName: 'getJobSignOffs' });
        },
        ...options,
      }),
    [_mutate]
  );

  return React.useMemo<typeof tuple>(() => [mutate, result], [mutate, result]);
};
